import { RouteItem } from '@eastcoal/router/types/route'

import { COST_STATISTICS_PAGE_UUID } from './constants/uuid'

export const costStatisticsRoute: RouteItem = {
  title: '扣费统计',
  uuid: COST_STATISTICS_PAGE_UUID,
  path: '/costStatistics',
  Component: () => import('./index')
}
